// extracted by mini-css-extract-plugin
export var featuresSection = "EACarousel-module--featuresSection--7a182";
export var panelContent = "EACarousel-module--panelContent--85dab";